import { t } from '@lingui/core/macro';

import { InstantSearch, InstantSearchSortOrder, type QueryState } from '@/components/InstantSearch';
import InstantSearchInput from '@/components/InstantSearchInput';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import ShareMenu from '@/features/ShareMenu';
import { type WEB_TRAFFIC_ACTIVITY_SORT_KEYS } from '@/router/searchParams/webTrafficSearchParams';

import ActivityOverviewTable from './ActivityOverviewTable';

const DEFAULT_QUERY_STATE: Partial<QueryState> = {
  size: 20,
  sortBy: 'metrics.lastActivityDate' satisfies WEB_TRAFFIC_ACTIVITY_SORT_KEYS,
  sortOrder: InstantSearchSortOrder.DESC,
};

const ActivityOverview = () => {
  return (
    <Page
      title={t`Web Traffic`}
      pageName={t`Activity`}
      exampleAIQuestions={exampleAIQuestions('analytics')}
    >
      <InstantSearch prefix="w" defaultQueryState={DEFAULT_QUERY_STATE}>
        <PageFilterProvider>
          <div className="flex w-full flex-col gap-6">
            <div className="flex items-start justify-between">
              <PageDateRangeFilter />
              <div className="flex items-center gap-2">
                <PendoPlaceholder />
                <InstantSearchInput />
                <ShareMenu notificationPageKey="company-activity" />
              </div>
            </div>
            <ActivityOverviewTable />
          </div>
        </PageFilterProvider>
      </InstantSearch>
    </Page>
  );
};

export default ActivityOverview;
